/* eslint-disable camelcase */
import apiRoutes from "../apiRoutes";
import { BaseCrudService } from "../baseCrudService";
import {
  SecuritySettingsData,
  DEFAULT_SECURITY_SETTINGS,
} from "../../models/securitySettingsData";

/**
 * Service for system settings
 * @extends BaseCrudService
 */
export class SecurityPoliciesService extends BaseCrudService {
  /**
   * Sends a request to the server to get the security settings.
   * If no policy is set, returns default values.
   * @returns {Promise<SecuritySettingsData>} The security settings data.
   */
  async getSecuritySettings(): Promise<SecuritySettingsData> {
    const response = await this.getAll<Partial<SecuritySettingsData>>(
      apiRoutes.password_policy
    );
    const data = response.data;

    // If data is undefined/null or an empty object, return default
    if (!data || Object.keys(data).length === 0) {
      return DEFAULT_SECURITY_SETTINGS;
    }

    return data as SecuritySettingsData;
  }
}
